import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
import { Avatar, Card, Divider, Flex, Heading, Link, Text, Tooltip } from '@applyboard/crystal-ui';
import { EmailOutlineIcon, PhoneOutlineIcon } from '@applyboard/ui-icons';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var AB_TEAM = 'ApplyBoard Recruitment Team';
var ELLIPSIS_TEXT_STYLE = Object.freeze({
  display: 'inline-block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '20vw'
});
export function YourAccountManager(_ref) {
  var email = _ref.email,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    phoneNumber = _ref.phoneNumber,
    profilePictureUrl = _ref.profilePictureUrl;
  var name = assembleName(firstName, lastName);
  return _jsxs(Card, {
    as: "article",
    variant: "outlined",
    "aria-label": "Your Account Manager",
    children: [_jsx(Card.Header, {
      children: _jsx(Heading, {
        level: 2,
        children: "Your account manager"
      })
    }), _jsx(Divider, {
      direction: "horizontal"
    }), _jsxs(Flex, {
      align: "start",
      gap: 4,
      direction: "column",
      children: [_jsx(Avatar, {
        image: profilePictureUrl,
        initials: !profilePictureUrl ? extractInitials(name) : undefined,
        intent: "primary",
        size: "sm",
        alt: "Account Manager Profile Picture"
      }), _jsxs(Flex, {
        as: "div",
        direction: "column",
        gap: 2,
        children: [_jsx(Text, {
          variant: "titleM",
          children: _jsx("span", {
            style: {
              display: 'inline-block',
              maxWidth: '20vw',
              overflowWrap: 'anywhere'
            },
            children: name
          })
        }), _jsxs(Flex, {
          gap: 4,
          children: [_jsx(EmailOutlineIcon, {}), _jsx(Text, {
            variant: "bodyM",
            children: _jsx(Tooltip, {
              label: email,
              children: _jsx(Link, {
                href: "mailto:".concat(email),
                children: _jsx("span", {
                  style: ELLIPSIS_TEXT_STYLE,
                  children: email
                })
              })
            })
          })]
        }), phoneNumber && _jsxs(Flex, {
          gap: 4,
          children: [_jsx(PhoneOutlineIcon, {
            "data-testid": "account-manager-phone-icon"
          }), _jsx(Text, {
            variant: "bodyM",
            children: _jsx(Tooltip, {
              label: phoneNumber,
              children: _jsx(Link, {
                href: "tel:".concat(phoneNumber),
                children: _jsx("span", {
                  style: ELLIPSIS_TEXT_STYLE,
                  children: phoneNumber
                })
              })
            })
          })]
        })]
      })]
    })]
  });
}
function extractInitials(name) {
  if (name === AB_TEAM) {
    return 'AB';
  }
  var words = name.split(' ');
  var initials = '';
  for (var index = 0; index < Math.min(2, words.length); index++) {
    var word = words[index];
    if (word.length) {
      initials += word[0].toUpperCase();
    }
  }
  return initials;
}
function assembleName(firstName, lastName) {
  if (!firstName || !lastName) {
    return AB_TEAM;
  }
  return "".concat(firstName, " ").concat(lastName);
}